export const GET_PATIENTS_LIST = 'charts/GET_PATIENTS_LIST'
export const GET_PATIENTS_LIST_SUCCESS = 'charts/GET_PATIENTS_LIST_SUCCESS'
export const GET_PATIENTS_LIST_ERROR = 'charts/GET_PATIENTS_LIST_ERROR'

export const GET_PRESCRIPTIONS = 'chartsPage/GET_PRESCRIPTIONS'
export const GET_RESCRIPTIONS_SUCCESS = 'chartsPage/GET_RESCRIPTIONS_SUCCESS'
export const GET_RESCRIPTIONS_ERROR = 'chartsPage/GET_RESCRIPTIONS_ERROR'

export const GET_AUDI_LOGS = 'chartsPage/GET_AUDI_LOGS'
export const GET_GET_AUDI_LOGS_SUCCESS = 'chartsPage/GET_GET_AUDI_LOGS_SUCCESS'
export const GET_GET_AUDI_LOGS_ERROR = 'chartsPage/GET_GET_AUDI_LOGS_ERROR'

export const GET_PATIENT_INFO = 'charts/GET_PATIENT_INFO'
export const GET_PATIENT_INFO_SUCCESS = 'charts/GET_PATIENT_INFO_SUCCESS'
export const GET_PATIENT_INFO_ERROR = 'charts/GET_PATIENT_INFO_ERROR'

export const GET_PATIENT_CHART_PRINTED_VERSION = 'charts/GET_PATIENT_CHART_PRINTED_VERSION'
export const GET_PATIENT_CHART_PRINTED_VERSION_SUCCESS = 'charts/GET_PATIENT_CHART_PRINTED_VERSION_SUCCESS'
export const GET_PATIENT_CHART_PRINTED_VERSION_ERROR = 'charts/GET_PATIENT_CHART_PRINTED_VERSION_ERROR'

export const GET_ALERTS_LIST = 'charts/GET_ALLERTS_LIST'
export const GET_ALERTS_LIST_SUCCESS = 'charts/GET_ALLERTS_LIST_SUCCESS'
export const GET_ALERTS_LIST_ERROR = 'charts/GET_ALLERTS_LIST_ERROR'

export const GET_PATIENT_UPCOMING_VISITS = 'charts/GET_PATIENT_UPCOMING_VISITS'
export const GET_PATIENT_UPCOMING_VISITS_SUCCESS = 'charts/GET_PATIENT_UPCOMING_VISITS_SUCCESS'
export const GET_PATIENT_UPCOMING_VISITS_ERROR = 'charts/GET_PATIENT_UPCOMING_VISITS_ERROR'

export const ADD_ALLERGY = 'charts/ADD_ALLERGY'
export const ADD_ALLERGY_SUCCESS = 'charts/ADD_ALLERGY_SUCCESS'
export const ADD_ALLERGY_ERROR = 'charts/ADD_ALLERGY_ERROR'

export const ADD_ALERT = 'charts/ADD_ALERT'
export const ADD_ALERT_SUCCESS = 'charts/ADD_ALERT_SUCCESS'
export const ADD_ALERT_ERROR = 'charts/ADD_ALERT_ERROR'

export const DELETE_ALLERGY = 'charts/DELETE_ALLERGY'
export const DELETE_ALLERGY_SUCCESS = 'charts/DELETE_ALLERGY_SUCCESS'
export const DELETE_ALLERGY_ERROR = 'charts/DELETE_ALLERGY_ERROR'

export const MARK_ALERTS_AS_READ = 'charts/MARK_ALERTS_AS_READ'
export const MARK_ALERTS_AS_READ_SUCCESS = 'charts/MARK_ALERTS_AS_READ_SUCCESS'
export const MARK_ALERTS_AS_READ_ERROR = 'charts/MARK_ALERTS_AS_READ_ERROR'

export const UPDATE_ACCOUNT_INFO = 'charts/UPDATE_ACCOUNT_INFO'
export const UPDATE_ACCOUNT_INFO_SUCCESS = 'charts/UPDATE_ACCOUNT_INFO_SUCCESS'
export const UPDATE_ACCOUNT_INFO_ERROR = 'charts/UPDATE_ACCOUNT_INFO_ERROR'

export const UPDATE_GENERAL_INFO = 'charts/UPDATE_GENERAL_INFO'
export const UPDATE_GENERAL_INFO_SUCCESS = 'charts/UPDATE_GENERAL_INFO_SUCCESS'
export const UPDATE_GENERAL_INFO_ERROR = 'charts/UPDATE_GENERAL_INFO_ERROR'

export const UPDATE_VISIT_CREDIT = 'charts/UPDATE_VISIT_CREDIT'
export const UPDATE_VISIT_CREDIT_SUCCESS = 'charts/UPDATE_VISIT_CREDIT_SUCCESS'
export const UPDATE_VISIT_CREDIT_ERROR = 'charts/UPDATE_VISIT_CREDIT_ERROR'

export const SEARCH_PHARMACIES = 'charts/SEARCH_PHARMACIES'
export const SEARCH_PHARMACIES_SUCCESS = 'charts/SEARCH_PHARMACIES_SUCCESS'
export const SEARCH_PHARMACIES_ERROR = 'charts/SEARCH_PHARMACIES_ERROR'

export const SET_PATIENTS_LIST = 'charts/SET_PATIENTS_LIST'
export const SET_PATIENT_INFO = 'charts/SET_PATIENT_INFO'
export const SET_IS_PATIENT_INFO_LOADED_SUCCESS = 'charts/SET_IS_PATIENT_INFO_LOADED_SUCCESS'
export const SET_IS_ALERTS_LOADED_SUCCESS = 'charts/SET_IS_ALERTS_LOADED_SUCCESS'
export const SET_IS_ALLERGY_ADDED_SUCCESS = 'charts/SET_IS_ALLERGY_ADDED_SUCCESS'
export const SET_IS_ALLERGY_DELETED_SUCCESS = 'charts/SET_IS_ALLERGY_DELETED_SUCCESS'
export const SET_IS_ALERT_ADDED_SUCCESS = 'charts/SET_IS_ALERT_ADDED_SUCCESS'
export const SET_IS_ACCOUNT_UPDATED_SUCCESS = 'charts/SET_IS_ACCOUNT_UPDATED_SUCCESS'
export const SET_IS_GENERAL_INFO_UPDATED_SUCCESS = 'charts/SET_IS_GENERAL_INFO_UPDATED_SUCCESS'
export const SET_IS_PHARMACIES_SEARCHING_DONE = 'charts/SET_IS_PHARMACIES_SEARCHING_DONE'
export const SET_ERROR = 'charts/SET_ERROR'
export const SET_IS_PRINTED_VERSION_OF_CHARTS_READY = 'charts/SET_IS_PRINTED_VERSION_OF_CHARTS_READY'
export const SET_PHONE_VALIDATION = 'charts/SET_PHONE_VALIDATION'
export const SET_PATIENT_UPCOMING_VISITS = 'charts/SET_PATIENT_UPCOMING_VISITS'
export const SET_PATIENT_PAST_VISITS = 'charts/SET_PATIENT_PAST_VISITS'
export const SET_PATIENT_STATUS_CHANGED_SUCCESS = 'charts/SET_PATIENT_STATUS_CHANGED_SUCCESS'
export const SET_NEW_PATIENTS_LIST = 'charts/SET_NEW_PATIENTS_LIST'

export const RESET_IS_VISIT_CREDIT_UPDATED_SUCCESS = 'charts/RESET_IS_VISIT_CREDIT_UPDATED_SUCCESS'
export const RESET_SEARCH_PHARMACY_LIST = 'charts/RESET_SEARCH_PHARMACY_LIST'

export const EDIT_ALERT = 'charts/EDIT_ALERT'
export const EDIT_ALERT_SUCCESS = 'charts/EDIT_ALERT_SUCCESS'
export const EDIT_ALERT_ERROR = 'charts/EDIT_ALERT_ERROR'

export const DELETE_ALERT = 'charts/DELETE_ALERT'
export const DELETE_ALERT_SUCCESS = 'charts/DELETE_ALERT_SUCCESS'
export const DELETE_ALERT_ERROR = 'charts/DELETE_ALERT_ERROR'

export const GET_PATIENT_PAST_VISITS = 'charts/GET_PATIENT_PAST_VISITS'
export const GET_PATIENT_PAST_VISITS_SUCCESS = 'charts/GET_PATIENT_PAST_VISITS_SUCCESS'
export const GET_PATIENT_PAST_VISITS_ERROR = 'charts/GET_PATIENT_PAST_VISITS_ERROR'

export const GET_MEDIA_FILES = 'charts/GET_MEDIA_FILES'
export const GET_MEDIA_FILES_SUCCESS = 'charts/GET_MEDIA_FILES_SUCCESS'
export const GET_MEDIA_FILES_ERROR = 'charts/GET_MEDIA_FILES_ERROR'

export const SET_MEDIA_FILE_TAGS = 'charts/SET_MEDIA_FILE_TAGS'
export const SET_MEDIA_FILE_TAGS_SUCCESS = 'charts/SET_MEDIA_FILE_TAGS_SUCCESS'
export const SET_MEDIA_FILE_TAGS_ERROR = 'charts/GET_MEDIA_FILES_ERROR'

export const GET_INTAKE_FORM = 'charts/GET_INTAKE_FORM'
export const GET_INTAKE_FORM_SUCCESS = 'charts/GET_INTAKE_FORM_SUCCESS'
export const GET_INTAKE_FORM_ERROR = 'charts/GET_INTAKE_FORM_ERROR'

export const ADD_MEDIA_FILE = 'charts/ADD_MEDIA_FILE'
export const ADD_MEDIA_FILE_SUCCESS = 'charts/ADD_MEDIA_FILE_SUCCESS'
export const ADD_MEDIA_FILE_ERROR = 'charts/ADD_MEDIA_FILE_ERROR'

export const DELETE_MEDIA_FILE = 'charts/DELETE_MEDIA_FILE'
export const DELETE_MEDIA_FILE_SUCCESS = 'charts/DELETE_MEDIA_FILE_SUCCESS'
export const DELETE_MEDIA_FILE_ERROR = 'charts/DELETE_MEDIA_FILE_ERROR'

export const VALIDATE_PHONE_NUMBER = 'charts/VALIDATE_PHONE_NUMBER'
export const VALIDATE_PHONE_NUMBER_SUCCESS = 'charts/VALIDATE_PHONE_NUMBER_SUCCESS'
export const VALIDATE_PHONE_NUMBER_ERROR = 'charts/VALIDATE_PHONE_NUMBER_ERROR'

export const SET_ON_HOLD_STATUS = 'charts/SET_ON_HOLD_STATUS'
export const SET_ON_HOLD_STATUS_SUCCESS = 'charts/SET_ON_HOLD_STATUS_SUCCESS'
export const SET_ON_HOLD_STATUS_ERROR = 'charts/SET_ON_HOLD_STATUS_ERROR'

export const GET_INTAKE_FORMS = 'charts/GET_INTAKE_FORMS'
export const GET_INTAKE_FORMS_SUCCESS = 'charts/GET_INTAKE_FORMS_SUCCESS'
export const GET_INTAKE_FORMS_ERROR = 'charts/GET_INTAKE_FORMS_ERROR'

export const SET_PATIENT_HAS_ALLERGIES = 'charts/SET_PATIENT_HAS_ALLERGIES'
export const SET_PATIENT_HAS_ALLERGIES_SUCCESS = 'charts/SET_PATIENT_HAS_ALLERGIES_SUCCESS'
export const SET_PATIENT_HAS_ALLERGIES_ERROR = 'charts/SET_PATIENT_HAS_ALLERGIES_ERROR'

export const SET_PATIENT_HAS_NO_ALLERGIES = 'charts/SET_PATIENT_HAS_NO_ALLERGIES'
export const SET_PATIENT_HAS_NO_ALLERGIES_SUCCESS = 'charts/SET_PATIENT_HAS_NO_ALLERGIES_SUCCESS'
export const SET_PATIENT_HAS_NO_ALLERGIES_ERROR = 'charts/SET_PATIENT_HAS_NO_ALLERGIES_ERROR'
export const GET_UPCOMING_VISIT_REMARKS_SUCCESS = 'charts/GET_UPCOMING_VISIT_REMARKS_SUCCESS'
export const GET_UPCOMING_VISIT_REMARKS_ERROR = 'charts/GET_UPCOMING_VISIT_REMARKS_ERROR'
export const GET_UPCOMING_VISIT_REMARKS = 'charts/GET_UPCOMING_VISIT_REMARKS'
export const CREATE_UPCOMING_VISIT_REMARK = 'charts/CREATE_UPCOMING_VISIT_REMARK'
export const CREATE_UPCOMING_VISIT_REMARK_SUCCESS = 'charts/CREATE_UPCOMING_VISIT_REMARK_SUCCESS'
export const CREATE_UPCOMING_VISIT_REMARK_ERROR = 'charts/CREATE_UPCOMING_VISIT_REMARK_ERROR'

export const UPDATE_UPCOMING_VISIT_REMARK = 'charts/UPDATE_UPCOMING_VISIT_REMARK'
export const UPDATE_UPCOMING_VISIT_REMARK_SUCCESS = 'charts/UPDATE_UPCOMING_VISIT_REMARK_SUCCESS'
export const UPDATE_UPCOMING_VISIT_REMARK_ERROR = 'charts/UPDATE_UPCOMING_VISIT_REMARK_ERROR'

export const REMOVE_UPCOMING_VISIT_REMARK = 'charts/REMOVE_UPCOMING_VISIT_REMARK'
export const REMOVE_UPCOMING_VISIT_REMARK_SUCCESS = 'charts/REMOVE_UPCOMING_VISIT_REMARK_SUCCESS'
export const REMOVE_UPCOMING_VISIT_REMARK_ERROR = 'charts/REMOVE_UPCOMING_VISIT_REMARK_ERROR'

export const SET_ON_HOLD_STATUS_WITH_REASON = 'charts/SET_ON_HOLD_STATUS_WITH_REASON'
export const SET_ON_HOLD_STATUS_WITH_REASON_SUCCESS = 'charts/SET_ON_HOLD_STATUS_WITH_REASON_SUCCESS'
export const SET_ON_HOLD_STATUS_WITH_REASON_ERROR = 'charts/SET_ON_HOLD_STATUS_WITH_REASON_ERROR'

export const ADD_RECENTLY_VIEWED_CHART = 'charts/ADD_RECENTLY_VIEWED_CHART'
